import React from "react";
import styled from "styled-components";
import {displayCriticality} from "../../utils/utils";
import {Field} from "formik";


const CriticalityRadioButton = ({
                                    criticality,
                                    displayLabel,
                                    mandatoryField = false,
                                }) => {

    const criticalityValues = [1, 2]

    return (
        <Container className={'criticality-radio-btn'}>
            {displayLabel &&
            <label> Criticité {mandatoryField ? "*" : ""} </label>
            }
            <InputsContainer>
                {criticalityValues.map((i, index) => (
                    <label
                        key={index}>
                        <Field
                            key={index}
                            type="radio"
                            checked={criticality?.toString() === i.toString()}
                            value={i}
                            name="criticality"
                            />
                        {displayCriticality(i)}
                    </label>
                ))}
            </InputsContainer>
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5em;
  border-radius: 10px;
  width: 100%;
  label {
    font-weight: 700;
  }`

const InputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  label > input {
    opacity: 0;
    position: absolute;
    display: none;
  }

  label > input + div {
    display: flex;
    border-radius: 50px;
    width: 7em;
    height: 2.5em;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(166, 172, 181, 0.3);
    background-color: transparent;
    justify-content: space-evenly;
    align-items: center;
    margin-right: 0.5em;
    font-size: 0.9em;
  }

  label > input:hover + div {
    cursor: pointer;
    background-color: var(--color-purple-lighten);
    border-color: transparent;
  }
  label > input:checked + div {
    background-color: var(--color-purple-lighten);
    border-color: transparent;
  }
`




export default CriticalityRadioButton;